var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ApplicationWrapper",
    {
      attrs: {
        showTwoActionLines: this.showTwoActionLines,
        headerBackTooltip: _vm.fromMyBookings
          ? _vm.$t("overview.mybookings_header_backToBookingOverview")
          : _vm.$t("overview.details_header_backToCourseOverview"),
        headerImage: _vm.course.CourseImage,
        headerTitle: _vm.course.CourseTitle,
        disableBackButton: _vm.isReservating || _vm.isBooking,
      },
      on: {
        onButtonBackClick: _vm.handleButtonBackClick,
        "update:actionArea": _vm.handleActionAreaChanged,
      },
    },
    [
      _c(
        "template",
        { slot: "details" },
        [
          _vm.needsImageSlider
            ? _c(
                "v-carousel",
                { attrs: { "hide-delimiter-background": "", height: "auto" } },
                _vm._l(
                  _vm.course.additionalDetails.CourseImageList,
                  function (courseImage, index) {
                    return _c(
                      "v-carousel-item",
                      { key: "courseImage_" + index },
                      [
                        _c("v-img", {
                          attrs: {
                            src: _vm.base64ImgPrefix + courseImage,
                            "max-height": "350px",
                            contain: "",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e(),
          _vm.needsImageSlider
            ? _c("v-divider", { staticClass: "my-4" })
            : _vm._e(),
          _c(
            "v-list",
            {
              staticClass: "nomargin-firstchild nomargin-lastchild",
              attrs: { "two-line": "" },
            },
            [
              _c("Detail", {
                attrs: {
                  appendIcon: !_vm.isNoWs(
                    _vm.course.additionalDetails.CourseLeaderEMail
                  )
                    ? "mdi-email"
                    : "",
                  prependIcon: _vm.isNoWs(_vm.leaderDetailsIconOrPortrait)
                    ? "mdi-account"
                    : "",
                  prependImage: !_vm.isNoWs(_vm.leaderDetailsIconOrPortrait)
                    ? _vm.leaderDetailsIconOrPortrait
                    : "",
                  title: _vm.course.additionalDetails.CourseLeader,
                  subTitle: _vm.$t("overview.details_content_courseLeader"),
                  appendIconTooltip: _vm.$t(
                    "overview.details_content_mailToCourseLeader",
                    _vm.course.additionalDetails
                      ? [
                          _vm.course.additionalDetails.CourseLeader,
                          _vm.course.additionalDetails.CourseLeaderEMail,
                        ]
                      : undefined
                  ),
                },
                on: { onActionIconClick: _vm.mailtoCourseLeader },
              }),
              _c(
                "Detail",
                {
                  attrs: {
                    expandable: true,
                    appendIconTooltip: _vm.$t("common.label_copyToClipboard"),
                    prependIcon: "mdi mdi-information-slab-box-outline",
                    title: _vm.$t("common.label_description"),
                  },
                },
                [
                  _c("template", { slot: "expansion-content" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.course.CourseDesignation),
                      },
                    }),
                  ]),
                ],
                2
              ),
              _c("Detail", {
                attrs: {
                  prependIcon: "mdi-wallet",
                  title: _vm.contribution,
                  subTitle: _vm.$t("overview.details_content_contribution"),
                },
              }),
              _c("Detail", {
                attrs: {
                  prependIcon: "mdi-calendar-range",
                  title: _vm.getFancyDatestring(
                    _vm.course.CourseStartDate,
                    _vm.course.CourseEndDate
                  ),
                  subTitle: _vm.$t("overview.details_content_availability"),
                },
              }),
              _c(
                "Detail",
                {
                  attrs: {
                    prependIcon: "mdi-account-multiple",
                    expandable: true,
                  },
                },
                [
                  _c("template", { slot: "expansion-header" }, [
                    _c(
                      "div",
                      { staticClass: "tag-container" },
                      _vm._l(_vm.course.tags, function (tag, index) {
                        return _c("Tag", {
                          key:
                            "tag_courseDetail" +
                            _vm.course.CourseId +
                            "_" +
                            index,
                          attrs: {
                            tagCount: _vm.course.tags.length,
                            tagInfo: tag,
                          },
                        })
                      }),
                      1
                    ),
                  ]),
                  _c(
                    "template",
                    { slot: "expansion-content" },
                    [
                      _vm.course.MaxMemberNumber > 0
                        ? _c(
                            "v-list-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _vm.currentBreakpoint > 1
                                    ? _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "overview.details_content_limitation"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "overview.details_content_limitation_minmax"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                  _vm.currentBreakpoint > 1
                                    ? _c("v-list-item-subtitle", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "overview.details_content_minMembers",
                                                [_vm.course.MinMemberNumber]
                                              ) +
                                                " — " +
                                                _vm.$t(
                                                  "overview.details_content_maxMembers",
                                                  [_vm.course.MaxMemberNumber]
                                                )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("v-list-item-subtitle", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.course.MinMemberNumber) +
                                            "  —  " +
                                            _vm._s(_vm.course.MaxMemberNumber) +
                                            " "
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-list-item",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "overview.details_content_currentMembers"
                                    )
                                  )
                                ),
                              ]),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "overview.details_content_members",
                                        [_vm.course.MemberNumber]
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.SessionData.club.courseConfig.CanCourseReservation
                        ? _c(
                            "v-list-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "overview.details_content_currentReservations"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "overview.details_content_reservationAmount",
                                            [_vm.course.ReservationNumber]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "Detail",
                { attrs: { prependIcon: "mdi-calendar", expandable: true } },
                [
                  _c(
                    "template",
                    { slot: "expansion-header" },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c("v-col", { attrs: { cols: "4" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("overview.details_content_meetings", [
                                    _vm.course.meetings.length,
                                  ])
                                )
                            ),
                          ]),
                          _c(
                            "v-col",
                            {
                              staticClass: "text--secondary",
                              attrs: { cols: "8" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { "no-gutters": "" },
                                },
                                [
                                  _c("v-spacer"),
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("overview.label_nextMeeting", [
                                            _vm.getNextMeetingDateCourse(
                                              _vm.course
                                            ),
                                          ])
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "expansion-content" },
                    _vm._l(_vm.course.meetings, function (meeting, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: "meeting_" + index,
                          attrs: { dense: "", "three-line": "" },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "overview.details_content_meetings_location",
                                        [meeting.Location]
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$d(
                                        new Date(meeting.MeetingDate),
                                        "longDate"
                                      )
                                    ) +
                                    " "
                                ),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      meeting.WholeDay
                                        ? _vm.$t("overview.meetingWholeDay")
                                        : _vm.getFancyTimestring(
                                            meeting.MeetingTimeFrom,
                                            meeting.MeetingTimeTo,
                                            true
                                          )
                                    ),
                                  },
                                }),
                              ]),
                              _c("v-list-item-subtitle", [
                                _c("b", { staticClass: "green--text" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isNextMeetingDate(
                                          meeting.MeetingDate
                                        )
                                          ? _vm
                                              .$t("common.label_nextMeeting")
                                              .toUpperCase()
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          meeting.WholeDay
                            ? _c(
                                "v-list-item-action",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          dark: "",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v(" mdi-information ")]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "overview.details_content_meetingWholeDay"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.SessionData.member.permissions.KurseSchreiben
        ? _c(
            "template",
            { slot: "actionbuttons" },
            [
              _c(
                "v-row",
                { attrs: { justify: "center", "no-gutters": "" } },
                [
                  _vm.course.booked && !_vm.course.payed
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          style: _vm.showTwoActionLines ? "width: 95%" : "",
                          attrs: {
                            loading: _vm.isBooking,
                            disabled: _vm.isReservating,
                            color: "error",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleBookClick(_vm.course)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "overview.details_action_removeCourseBooking"
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : !_vm.course.booked &&
                      !_vm.course.payed &&
                      !_vm.isBookedOut
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          style: _vm.showTwoActionLines ? "width: 95%" : "",
                          attrs: {
                            loading: _vm.isBooking,
                            disabled: _vm.isReservating,
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleBookClick(_vm.course)
                            },
                          },
                        },
                        [
                          _vm.course.RegularPrice == 0.0
                            ? _c("div", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "overview.details_action_addFreeCourseBooking"
                                    )
                                  ),
                                },
                              })
                            : _c("div", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "overview.details_action_addCourseBooking"
                                    )
                                  ),
                                },
                              }),
                        ]
                      )
                    : _vm.isBookedOut
                    ? _c(
                        "p",
                        {
                          staticClass: "text-center ma-0",
                          staticStyle: {
                            "align-self": "center",
                            "text-wrap": "balance",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("common.label_noBookingFullCourses")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.course.payed
                    ? _c(
                        "p",
                        {
                          staticClass: "text-center ma-0",
                          staticStyle: {
                            "align-self": "center",
                            "text-wrap": "balance",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("common.label_noUnbookingPayedCourses")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.course.reserved && !_vm.course.booked && !_vm.course.payed
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          style: _vm.showTwoActionLines ? "width: 95%" : "",
                          attrs: {
                            loading: _vm.isReservating,
                            disabled: _vm.isBooking,
                            color: "error",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleReservateClick(_vm.course)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "overview.details_action_removeCourseReservation"
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : !_vm.course.reserved &&
                      !_vm.course.booked &&
                      !_vm.course.payed
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          style: _vm.showTwoActionLines ? "width: 95%" : "",
                          attrs: {
                            loading: _vm.isReservating,
                            disabled: _vm.isBooking,
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleReservateClick(_vm.course)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "overview.details_action_addCourseReservation"
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c("template", { slot: "actionbuttons" }, [
            _c("p", {
              staticClass: "text-center ma-0",
              staticStyle: { "align-self": "center" },
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.label_noBookingPermsCourse")),
              },
            }),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }